const state = { 
    mainModal: false,
}

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
}

const actions = { 
}

const getters = {  
    mainModal: state => state.mainModal
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
};